// src/pages/InteractPage.js
// Filepath: // src/pages/InteractPage.js
import React, { useCallback, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BrandLogo from "../components/BrandLogo";
import { signOutSafely } from "../services/authService";

export default function InteractPage() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const handleSignOut = useCallback(async () => {
    if (busy) return;
    setBusy(true);
    try {
      await signOutSafely();
    } catch {
      // ignore errors; we will navigate regardless
    } finally {
      // Replace history entry so back doesn't return to this page
      navigate("/signin", { replace: true });
      setBusy(false);
    }
  }, [busy, navigate]);

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", p: 3 }}>
      <Box sx={{ textAlign: "center", maxWidth: 520 }}>
        <BrandLogo size={100} mb={8} />
        <Typography variant="h4" sx={{ mb: 1 }}>
          Connected!
        </Typography>
        <Typography sx={{ opacity: 0.8, mb: 3 }}>
          Kbean TV is now paired and ready to use.
        </Typography>
      </Box>

      {/* Bottom fixed sign-out bar */}
      <Box
        component="footer"
        sx={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          p: 2,
          display: "flex",
          justifyContent: "center",
          // ensure it's tappable above device notches/home indicators
          pb: "calc(env(safe-area-inset-bottom) + 16px)",
        }}
      >
        <Button
          onClick={handleSignOut}
          variant="outlined"
          disableElevation
          disabled={busy}
          aria-label="Sign out"
        >
          {busy ? "Signing out..." : "Sign out"}
        </Button>
      </Box>
    </Box>
  );
}
